import { createAction } from '@reduxjs/toolkit'

import { ScheduleOptionsState } from './types'

export const resetScheduleOptionsAction = createAction<void>('schedule-options/reset-schedule-options')
export const setScheduleOptionsAction = createAction<ScheduleOptionsState>('schedule-options/set-schedule-options')
